import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const constantRouterMap = [
    // {
    //   path: '/',
    //   component: () => import('@/views/login'),
    //   hidden: true
    // },
    {
        path: '/',
        component: () =>
            import ('@/views/main'),
        redirect: '/home',
        name: '首页',
        hidden: true,
        children: [{
                "path": "/home",
                "name": "home",
                "component": () =>
                    import ("@/views/home")
            },
            {
                "path": "/introduce",
                "name": "introduce",
                "component": () =>
                    import ("@/views/introduce")
            },
            {
                "path": "/contactUs",
                "name": "contactUs",
                "component": () =>
                    import ("@/views/contactUs")
            },
            {
                "path": "/lesson",
                "name": "lesson",
                "component": () =>
                    import ("@/views/lesson")
            },
            {
                "path": "/news",
                "name": "news",
                "component": () =>
                    import ("@/views/news")
            },
            {
                "path": "/recruit",
                "name": "recruit",
                "component": () =>
                    import ("@/views/recruit")
            },
            // {
            //     "path": "/old_service",
            //     "name": "old_service",
            //     "component": () =>
            //         import ("@/views/old_service")
            // },
            {
                "path": "/productsTech",
                "name": "productsTech",
                "component": () =>
                    import ("@/views/productsTech")
            },
            // {
            //     "path": "/old_solutionCase",
            //     "name": "old_solutionCase",
            //     "component": () =>
            //         import ("@/views/old_solutionCase")
            // },
            {
                "path": "/articleDetails",
                "name": "articleDetails",
                "component": () =>
                    import ("@/views/articleDetails")
            },
            // {
            //     "path": "/old_new_articleDetails",
            //     "name": "old_new_articleDetails",
            //     "component": () =>
            //         import ("@/views/old_new_articleDetails")
            // },

            {
                "path": "/login",
                "name": "login",
                "component": () =>
                    import ("@/views/login")
            },
            {
                "path": "/download",
                "name": "download",
                "component": () =>
                    import ("@/views/download")
            },
            {
                "path": "/recruit_content",
                "name": "recruit_content",
                "component": () =>
                    import ("@/views/recruit_content")
            },
            // {
            //     "path": "/old_recruit",
            //     "name": "old_recruit",
            //     "component": () =>
            //         import ("@/views/old_recruit")
            // },
            {
                "path": "/meeting",
                "name": "meeting",
                "component": () =>
                    import ("@/views/meeting")
            },
            {
                "path": "/solutionCase",
                "name": "solutionCase",
                "component": () =>
                    import ("@/views/solutionCase")
            },
            {
                "path": "/solution_details",
                "name": "solution_details",
                "component": () =>
                    import ("@/views/solution_details")
            },
            {
                "path": "/products_articleDetails",
                "name": "products_articleDetails",
                "component": () =>
                    import ("@/views/products_articleDetails")
            }, {
                "path": "/smartPrivacy",
                "name": "smartPrivacy",
                "component": () =>
                    import ("@/views/smartPrivacy")
            }, {
                "path": "/introduceEn",
                "name": "introduceEn",
                "component": () =>
                    import ("@/views/introduceEn")
            }, {
                "path": "/solutionCaseEn",
                "name": "solutionCaseEn",
                "component": () =>
                    import ("@/views/solutionCaseEn")
            }, {
                "path": "/solution_detailsEn",
                "name": "solution_detailsEn",
                "component": () =>
                    import ("@/views/solution_detailsEn")
            }, {
                "path": "/contactUsEn",
                "name": "contactUsEn",
                "component": () =>
                    import ("@/views/contactUsEn")
            }, {
                "path": "/newsEn",
                "name": "newsEn",
                "component": () =>
                    import ("@/views/newsEn")
            }, {
                "path": "/articleDetailsEn",
                "name": "articleDetailsEn",
                "component": () =>
                    import ("@/views/articleDetailsEn")
            }, {
                "path": "/lessonEn",
                "name": "lessonEn",
                "component": () =>
                    import ("@/views/lessonEn")
            }, {
                "path": "/waterIntro",
                "name": "waterIntro",
                "component": () =>
                    import ("@/views/waterIntro")
            }, {
                "path": "/smartIntro",
                "name": "smartIntro",
                "component": () =>
                    import ("@/views/smartIntro")
            }, {
                "path": "/alarmIntro",
                "name": "alarmIntro",
                "component": () =>
                    import ("@/views/alarmIntro")
            }, {
                "path": "/waterPrivacy",
                "name": "waterPrivacy",
                "component": () =>
                    import ("@/views/waterPrivacy")
            }, {
                "path": "/smartPrivacy",
                "name": "smartPrivacy",
                "component": () =>
                    import ("@/views/smartPrivacy")
            }, {
                "path": "/alarmPrivacy",
                "name": "alarmPrivacy",
                "component": () =>
                    import ("@/views/alarmPrivacy")
            },
            {
                "path": "/downloadCenter",
                "name": "downloadCenter",
                "component": () =>
                    import ("@/views/downloadCenter")
            },
            
            // ...otherModulesRouter
        ]
    }
]
export default new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js